/**
 * Sylius shipping calculators return -1 cent when a quote cannot be produced.
 * Order pricing exposes that as -0.01 dollars.
 */
export function isShippingQuoteUnavailable(shipping: number | null | undefined): boolean {
  return typeof shipping === 'number' && shipping < 0;
}

/** Dollar amount to add back to order totals when shipping is the unavailable sentinel. */
export function shippingUnavailableTotalAdjustment(shipping: number | null | undefined): number {
  if (!isShippingQuoteUnavailable(shipping)) {
    return 0;
  }

  return -(shipping ?? 0);
}
